import AppLoader from '../../../../features/appLoader/AppLoader';
import Content from '../Сontent/Content';
import useShareLogic from '../../model/hooks/useShareLogic';
import { useContent } from '../../../../../redux/reducer/content';

export default function Share() {
  const { viewedFriend } = useContent();

  useShareLogic();

  return !viewedFriend ? <AppLoader /> : <Content />;
}
